// extracted by mini-css-extract-plugin
module.exports = {"container":"Menu_container_26uic","blackText":"Menu_blackText_3taa_","accountNameRow":"Menu_accountNameRow_1kJyC","row":"Menu_row_2-wid","mainColumn":"Menu_mainColumn_1Y1DH"};